"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = exports.ClientCommandTypes = exports.ClientCommandActionTypes = void 0;
var common_impl_1 = require("./common-impl");
var configs_1 = require("../configs");
var auth = require("../authProvider");
var ClientCommandActionTypes;
(function (ClientCommandActionTypes) {
    ClientCommandActionTypes["CLIENT_COMMAND_POLL_STARTED"] = "CLIENT_COMMAND_POLL_STARTED";
    ClientCommandActionTypes["CLIENT_COMMAND_POLL_SUCCEEDED"] = "CLIENT_COMMAND_POLL_SUCCEEDED";
    ClientCommandActionTypes["CLIENT_COMMAND_POLL_FAILED"] = "CLIENT_COMMAND_POLL_FAILED";
})(ClientCommandActionTypes = exports.ClientCommandActionTypes || (exports.ClientCommandActionTypes = {}));
var ClientCommandTypes;
(function (ClientCommandTypes) {
    ClientCommandTypes["PROMPT_REFRESH"] = "PROMPT_REFRESH";
    ClientCommandTypes["REFRESH_SILENT"] = "REFRESH_SILENT";
    ClientCommandTypes["SHOW_INFO"] = "SHOW_INFO";
    ClientCommandTypes["SHOW_WARNING"] = "SHOW_WARNING";
    ClientCommandTypes["LOGOUT"] = "LOGOUT";
})(ClientCommandTypes = exports.ClientCommandTypes || (exports.ClientCommandTypes = {}));
exports.actionCreators = {
    getClientCommand: function () { return function (dispatch, getState) {
        var tenantId = auth.getTenantId();
        dispatch({ type: ClientCommandActionTypes.CLIENT_COMMAND_POLL_STARTED });
        fetch(configs_1.BASE_API_URI + "/client-commands/" + tenantId, {
            'headers': {
                'x-api-key': configs_1.QUERY_API_KEY
            },
            'method': 'GET'
        })
            .then(common_impl_1.handleErrors)
            .then(function (response) { return response.json(); })
            .then(function (result) {
            dispatch({ type: ClientCommandActionTypes.CLIENT_COMMAND_POLL_SUCCEEDED, clientCommand: result });
        })
            .catch(function (error) {
            if (error.text) {
                error.text().then(function (errorText) {
                    return dispatch({
                        type: ClientCommandActionTypes.CLIENT_COMMAND_POLL_FAILED, error: errorText
                    });
                });
            }
            else {
                dispatch({
                    type: ClientCommandActionTypes.CLIENT_COMMAND_POLL_FAILED, error: configs_1.ERROR_GENERIC_MESSAGE
                });
            }
        });
    }; }
};
// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.
var unloadedState = {
    isLoading: false,
    error: null,
    clientCommandEntity: {}
};
var reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case ClientCommandActionTypes.CLIENT_COMMAND_POLL_STARTED:
            return {
                isLoading: true,
                clientCommandEntity: state.clientCommandEntity,
                error: null
            };
        case ClientCommandActionTypes.CLIENT_COMMAND_POLL_SUCCEEDED:
            return {
                isLoading: false,
                clientCommandEntity: action.clientCommand,
                error: null
            };
        case ClientCommandActionTypes.CLIENT_COMMAND_POLL_FAILED:
            return {
                isLoading: false,
                clientCommandEntity: state.clientCommandEntity,
                error: action.error
            };
        default:
            return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=client-command.store.js.map